import React, {FC} from 'react';

/** 배송 정책 한국어 본문（content/zh·en과 구조 1:1，클래스명은 TermsOfUse__* BEM 재사용）。2026-09-17 AI 번역, 법률 문구는 비즈니스 검토 대기 */
const KoContent: FC = () => {
  return (
    <>
      <p className="v3-doc-meta">시행일: August 28, 2026</p>
      <p className="v3-doc-meta">최종 업데이트: August 28, 2026</p>
      <p>Xiangji 서비스를 선택해 주셔서 감사합니다.</p>
      <p>
        본 Xiangji 서비스 배송 정책(이하 “본 정책”이라 함)은 Xiangji가 사용자에게 제공하는 소프트웨어 서비스(SaaS), AI
        시각 콘텐츠 처리 및 기타 디지털 서비스의 배송 방식, 배송 시간, 서비스 개통 및 관련 사항을 설명합니다.
      </p>
      <p>
        <strong>
          Xiangji가 제공하는 모든 서비스는 디지털 서비스이며, 일반적으로 실물 상품의 생산, 보관 또는 물류 배송은
          포함하지 않습니다.
        </strong>
      </p>
      <section>
        <h2>1. 디지털 서비스의 배송</h2>
        <h3>서비스의 성격</h3>
        <p>
          Xiangji는 주로 인터넷을 통해 사용자에게 디지털 상품 및 서비스를 제공하며, 다음을 포함하되 이에 국한되지
          않습니다:
        </p>
        <ul>
          <li>이미지 번역;</li>
          <li>이미지 편집 및 보정;</li>
          <li>AI 이미지 생성;</li>
          <li>상품 장면 이미지 생성;</li>
          <li>상품 모델 이미지 생성;</li>
          <li>상품 대표 이미지 및 보조 이미지 생성;</li>
          <li>상품 상세 이미지 세트 생성;</li>
          <li>상품 상세 페이지 및 A+ 콘텐츠 생성;</li>
          <li>동영상 및 시각 콘텐츠 처리;</li>
          <li>파일 및 PSD 처리;</li>
          <li>API 및 기타 기술 서비스;</li>
          <li>구독 서비스 및 관련 멤버십 혜택;</li>
          <li>포인트, 크레딧 및 기타 디지털 서비스 혜택.</li>
        </ul>
        <p>
          <strong>
            위 서비스는 모두 Xiangji 웹사이트, 클라이언트 애플리케이션, 브라우저 확장 프로그램, API 또는 기타 온라인
            방식을 통해 배송되며, 실물 상품의 배송은 제공하지 않습니다.
          </strong>
        </p>
      </section>
      <section>
        <h2>2. 서비스 배송 방식</h2>
        <h3>계정 배송</h3>
        <p>
          계정 등록이 필요한 서비스의 경우, 등록 또는 로그인을 완료하고 해당 서비스가 성공적으로 개통되면 Xiangji 계정을
          통해 관련 서비스에 접근할 수 있습니다.
        </p>
        <h3>구독 서비스 배송</h3>
        <p>
          구독 서비스의 경우, 결제를 완료하고 주문 확인이 성공적으로 이루어지면 관련 구독 혜택이 일반적으로 Xiangji
          계정에 자동으로 연동됩니다.
        </p>
        <p>
          <strong>
            실물 발송이나 물류 배송을 기다리실 필요가 없으며, 구독 서비스는 일반적으로 주문이 완료되는 즉시 이용할 수
            있습니다.
          </strong>
        </p>
        <p>구체적인 구독 기간, 혜택 범위, 사용 한도 및 유효 기간은 구매 페이지 및 관련 구독 계약에 따릅니다.</p>
        <h3>크레딧 및 한도 배송</h3>
        <p>
          Xiangji가 제공하는 포인트, 크레딧, 사용 한도 또는 기타 디지털 혜택은 결제가 성공하고 주문 확인이 완료되면
          일반적으로 Xiangji 계정에 자동으로 지급됩니다.
        </p>
        <p>해당 혜택은 계정 잔액, 주문 기록 또는 관련 서비스 페이지에서 확인할 수 있습니다.</p>
        <h3>일회성 서비스 배송</h3>
        <p>
          이미지 번역, 이미지 편집, AI 이미지 생성, 상세 이미지 세트 생성 등 건당 또는 사용량 기준으로 과금되는 서비스의
          경우, 작업을 제출하고 해당 결제를 완료하시면 Xiangji는 상품 페이지에 표시된 서비스 절차에 따라 작업을
          처리합니다.
        </p>
        <p>
          <strong>
            생성 결과, 처리 결과 또는 기타 디지털 산출물은 일반적으로 Xiangji 제품 인터페이스를 통해 직접 배송되며,
            작업이 완료되면 이를 조회하거나 다운로드하거나 추가로 편집할 수 있습니다.
          </strong>
        </p>
        <h3>API 서비스</h3>
        <p>
          API 서비스의 경우, 계정 등록, API 서비스 개통 및 필요한 설정을 완료하시면 Xiangji는 관련 API 서비스 계약 또는
          기술 문서에 따라 API 접근 권한을 제공합니다.
        </p>
        <p>
          API 서비스의 구체적인 배송 방식, 호출 제한, 한도, 과금 방식 및 기술 요건은 API 서비스 페이지 및 관련 계약에
          따릅니다.
        </p>
      </section>
      <section>
        <h2>3. 배송 시간</h2>
        <h3>자동 배송</h3>
        <p>
          상품 페이지에 별도로 명시된 경우를 제외하고, Xiangji가 제공하는 표준 디지털 서비스는 일반적으로 자동화된
          방식으로 배송됩니다.
        </p>
        <p>
          <strong>
            결제 성공, 주문 확인 및 필요한 보안 인증이 완료되면, 관련 서비스는 일반적으로 즉시 또는 합리적인 시간 내에
            개통됩니다.
          </strong>
        </p>
        <h3>AI 생성 및 처리 서비스</h3>
        <p>
          AI 이미지 생성, 이미지 번역, 이미지 편집, 동영상 처리 및 기타 연산 집약적 서비스는 시스템 처리를 거쳐야
          합니다.
        </p>
        <p>
          작업 복잡도, 파일 크기, 서버 부하, AI 모델 처리 속도 및 기타 기술적 요인에 따라{' '}
          <strong>실제 처리 시간은 달라질 수 있습니다.</strong>
        </p>
        <p>
          상품 페이지에 표시되는 예상 처리 시간은 참고용이며, 특정 완료 시간에 대한 절대적인 약속을 구성하지 않습니다.
        </p>
        <h3>수작업 또는 특별 서비스</h3>
        <p>
          서비스에 수동 검토, 수동 처리, 특별 설정 또는 기타 추가 작업이 필요한 경우, 구체적인 배송 시간은 서비스
          페이지, 주문 페이지 또는 쌍방 간의 별도 합의에 따릅니다.
        </p>
      </section>
      <section>
        <h2>4. 주문 및 결제 확인</h2>
        <h3>결제 성공</h3>
        <p>주문 대금 결제를 완료하신 후, 결제 기관이 거래를 확인하는 데 일정 시간이 필요할 수 있습니다.</p>
        <p>
          <strong>
            Xiangji 시스템이 주문 결제의 성공을 확인한 후에야 관련 디지털 서비스 혜택이 본 정책에 따라 배송됩니다.
          </strong>
        </p>
        <h3>결제 이상</h3>
        <p>
          결제를 완료하셨는데도 Xiangji 계정에 주문 성공이 표시되지 않거나, 서비스 혜택이 지급되지 않았거나, 기타 이상이
          발생한 경우에는 즉시 Xiangji 고객센터로 문의해 주시기 바랍니다.
        </p>
        <p>Xiangji는 주문 및 결제 상태를 확인한 후 실제 상황에 따라 해당 사안을 처리하겠습니다.</p>
        <h3>제3자 결제</h3>
        <p>
          제3자 결제 기관을 통해 결제를 완료하시는 경우, 해당 기관에 거래 심사, 결제 지연, 환불 처리 또는 기타 기술적
          사유가 있을 수 있습니다.
        </p>
        <p>
          제3자 결제 기관 자체의 사유로 인한 결제 지연 또는 이상에 대해서는, Xiangji가 합리적인 범위 내에서 해결에
          협조하겠습니다.
        </p>
      </section>
      <section>
        <h2>5. 계정 및 서비스 접근</h2>
        <h3>계정에 대한 책임</h3>
        <p>
          <strong>
            등록 및 구매 시 사용하는 Xiangji 계정 정보가 정확하고 유효한지 확인하시고, 계정 및 로그인 자격 증명을
            안전하게 보관해 주시기 바랍니다.
          </strong>
        </p>
        <p>서비스 혜택은 일반적으로 구매 시 사용한 Xiangji 계정에 연동됩니다.</p>
        <h3>잘못된 계정</h3>
        <p>
          본인 사유로 잘못된 계정으로 서비스를 구매하여 관련 서비스 혜택이 다른 계정에 연동된 경우에는, 즉시 고객센터에
          문의하여 확인해 주시기 바랍니다.
        </p>
        <p>
          <strong>
            법령이 허용하는 범위 내에서, 귀하 본인의 조작 착오로 인해 발생한 서비스 혜택 이상에 따른 손실에 대하여
            Xiangji는 책임을 부담하지 않습니다.
          </strong>
        </p>
        <h3>계정 공유</h3>
        <p>
          Xiangji가 명시적으로 지원하는 기업용 에디션, 다중 사용자 협업 또는 기타 팀 기능의 경우를 제외하고, 계정을
          임대, 대여, 양도 또는 공유하는 방식으로 타인에게 서비스를 제공할 수 없습니다.
        </p>
      </section>
      <section>
        <h2>6. 배송 이상</h2>
        <p>다음 각 호의 상황에 해당하는 경우에는 즉시 Xiangji 고객센터로 문의해 주시기 바랍니다:</p>
        <ul>
          <li>결제는 성공했으나 서비스가 개통되지 않은 경우;</li>
          <li>포인트 또는 크레딧이 지급되지 않은 경우;</li>
          <li>구독 혜택이 적용되지 않은 경우;</li>
          <li>AI 작업이 장시간 동안 완료되지 않은 경우;</li>
          <li>완료된 작업을 정상적으로 조회하거나 다운로드할 수 없는 경우;</li>
          <li>API 서비스가 정상적으로 개통되지 않은 경우;</li>
          <li>기타 서비스 배송과 관련된 이상.</li>
        </ul>
        <p>
          Xiangji는 주문, 계정 및 시스템 기록을 확인한 후, 합리적인 범위 내에서 혜택을 재지급하거나, 작업을
          재처리하거나, 서비스를 복구하거나, 기타 합리적인 조치를 취하겠습니다.
        </p>
        <h3>시스템 사유</h3>
        <p>
          <strong>
            Xiangji 시스템 장애로 인해 실제로 구매하신 서비스 혜택이 올바르게 배송되지 않은 경우, 관련 주문 및 결제
            기록을 효과적으로 확인할 수 있다면 Xiangji는 실제 상황에 따라 해당 혜택을 재지급하거나 기타 합리적인 시정
            조치를 취하겠습니다.
          </strong>
        </p>
        <h3>사용자 사유</h3>
        <p>다음 사유로 인해 발생한 배송 이상에 대하여, Xiangji는 법령이 허용하는 범위 내에서 책임을 지지 않습니다:</p>
        <ul>
          <li>사용자가 잘못된 계정 정보를 제공한 경우;</li>
          <li>사용자가 관련 계정 정보를 임의로 수정 또는 삭제한 경우;</li>
          <li>사용자의 계정이 이용 정지 또는 이용 제한된 경우;</li>
          <li>사용자의 기기, 네트워크 또는 소프트웨어 환경에 이상이 발생한 경우;</li>
          <li>사용자가 서비스에서 요구하는 바에 따라 필요한 설정을 완료하지 않은 경우;</li>
          <li>기타 사용자 본인의 사유로 서비스를 정상적으로 이용할 수 없는 경우.</li>
        </ul>
      </section>
      <section>
        <h2>7. 서비스 이용 불가 및 제3자 서비스</h2>
        <p>
          Xiangji의 일부 제품 및 기능은 클라우드 컴퓨팅 서비스, AI 모델, 번역 엔진, 네트워크 사업자, 결제 기관 및 기타
          제3자 기술 서비스에 의존합니다.
        </p>
        <p>
          <strong>
            제3자 서비스와 관련하여 발생하는 장애, 유지 보수, 업그레이드, 용량 제한, 인터페이스 조정 또는 Xiangji의
            합리적인 통제 범위를 벗어나는 기타 사유로 인해 서비스 지연, 중단 또는 일시적 이용 불가가 발생할 수 있습니다.
          </strong>
        </p>
        <p>이러한 경우, Xiangji는 실제 상황에 따라 다음을 포함하되 이에 국한되지 않는 합리적인 조치를 취하겠습니다:</p>
        <ul>
          <li>관련 서비스 복구;</li>
          <li>기술 서비스 전환;</li>
          <li>작업 처리 지연;</li>
          <li>관련 작업 재처리;</li>
          <li>해당 서비스 혜택 재지급;</li>
          <li>기타 합리적인 시정 조치.</li>
        </ul>
      </section>
      <section>
        <h2>8. 서비스 다운로드 및 데이터 보존</h2>
        <h3>다운로드</h3>
        <p>
          다운로드를 지원하는 AI 생성 결과, 번역 결과, 편집 결과 및 기타 디지털 콘텐츠는, Xiangji 제품 페이지에서
          제공하는 방식에 따라 다운로드하거나 내보낼 수 있습니다.
        </p>
        <h3>사용자 백업 책임</h3>
        <p>
          <strong>
            장기 보존이 필요한 생성 결과, 처리된 파일, 프로젝트 데이터 및 기타 중요 콘텐츠는 귀하가 적시에 백업하여야
            합니다.
          </strong>
        </p>
        <p>
          법령에 별도의 규정이 있거나 쌍방이 별도로 합의한 경우를 제외하고, Xiangji는 서비스가 종료되었거나, 계정이
          삭제되었거나, 플랫폼이 정한 보존 기간을 초과한 데이터를 영구 보관할 것을 약속하지 않습니다.
        </p>
        <h3>서비스 종료 후의 데이터</h3>
        <p>
          귀하의 계정이 탈퇴되거나, 서비스가 종료되거나, 관련 프로젝트가 플랫폼이 정한 보존 기간을 초과하는 경우, 관련
          데이터는 삭제되거나 Xiangji 개인정보 처리방침에 따라 처리될 수 있습니다.
        </p>
      </section>
      <section>
        <h2>9. 배송 완료의 인정</h2>
        <p>원칙적으로 다음 각 호 중 어느 하나에 해당하면, 관련 디지털 서비스는 배송이 완료된 것으로 간주됩니다:</p>
        <ol>
          <li>구독 혜택이 귀하의 Xiangji 계정에 성공적으로 연동된 경우;</li>
          <li>포인트, 크레딧 또는 기타 디지털 혜택이 성공적으로 지급된 경우;</li>
          <li>API 접근 권한이 성공적으로 개통된 경우;</li>
          <li>AI 생성 또는 처리 작업이 완료되어 정상적으로 조회하거나 다운로드할 수 있게 된 경우;</li>
          <li>관련 서비스가 상품 페이지에서 약정한 바에 따라 귀하의 계정에 제공된 경우;</li>
          <li>쌍방이 합의한 기타 배송 조건이 충족된 경우.</li>
        </ol>
        <p>
          <strong>
            배송이 완료되었거나 실제로 사용된 디지털 서비스의 환불 및 관련 처리는 Xiangji 환불 정책, Xiangji 구독 서비스
            구매 계약 및 기타 적용 가능한 규칙을 따릅니다.
          </strong>
        </p>
      </section>
      <section>
        <h2>10. 본 정책의 변경</h2>
        <p>
          <strong>
            Xiangji는 법령의 변경, 사업의 발전, 제품 조정 및 기술 업그레이드를 고려하여 본 배송 정책을 수정 또는 보완할
            권리를 보유합니다.
          </strong>
        </p>
        <p>
          본 정책에 중대한 변경이 발생하는 경우, Xiangji는 웹사이트 공지, 제품 페이지, 팝업, 서비스 내 알림 또는 기타
          합리적인 방식을 통해 안내하겠습니다.
        </p>
        <p>수정된 정책은 공지일 또는 지정된 시행일부터 효력이 발생합니다.</p>
      </section>
      <section>
        <h2>11. 문의하기</h2>
        <p>
          서비스 배송, 주문 상태, 서비스 개통 또는 기타 관련 사항에 대해 궁금한 점이 있으시면, 다음 방법으로 문의하실 수
          있습니다:
        </p>
        <ul>
          <li>
            <strong>공식 웹사이트: </strong>
            <a href="https://www.xiangjifanyi.com/" rel="noreferrer" target="_blank">
              https://www.xiangjifanyi.com/
            </a>
          </li>
          <li>
            <strong>온라인 고객센터: </strong>Xiangji 제품 내 온라인 고객센터
          </li>
          <li>
            <strong>고객센터 이메일: </strong>
            <a href="mailto:bussiness@tosoiot.com">bussiness@tosoiot.com</a>
          </li>
          <li>
            <strong>전화: </strong>+86 176 6407 5341
          </li>
        </ul>
        <p>문의하신 사항은 접수 후 합리적인 기간 내에 처리하겠습니다.</p>
        <p>
          <strong>
            본 정책에 규정되지 않은 사항은 Xiangji 이용약관, Xiangji 개인정보 처리방침, Xiangji 구독 서비스 구매 계약 및
            기타 적용 가능한 서비스 규칙을 따릅니다.
          </strong>
        </p>
      </section>
    </>
  );
};

export default KoContent;
